// iOS "Add to Home Screen" tip banner.
// Shows only in iOS Safari (not Chrome/Firefox/Edge on iOS) when the app
// isn't already running standalone. Dismissal is remembered forever.
import React, { useEffect, useState } from "react";
import { X, Export } from "@phosphor-icons/react";

const DISMISS_KEY = "hw:a2hs:dismissed";

function isIOSSafari() {
  const ua = navigator.userAgent || "";
  const isIOS = /iphone|ipad|ipod/i.test(ua);
  const isOtherBrowser = /crios|fxios|edgios|opios/i.test(ua);
  return isIOS && !isOtherBrowser;
}

function isStandalone() {
  return (
    window.navigator.standalone === true ||
    window.matchMedia?.("(display-mode: standalone)")?.matches
  );
}

export default function AddToHomeTip() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (localStorage.getItem(DISMISS_KEY)) return;
    } catch (_) {}
    if (isIOSSafari() && !isStandalone()) setShow(true);
  }, []);

  const dismiss = () => {
    try { localStorage.setItem(DISMISS_KEY, "1"); } catch (_) {}
    setShow(false);
  };

  if (!show) return null;
  return (
    <div
      className="fixed left-3 right-3 z-[65]"
      style={{ bottom: "calc(env(safe-area-inset-bottom, 0px) + 76px)" }}
      data-testid="a2hs-tip"
    >
      <div className="mx-auto max-w-md rounded-full bg-forest text-cream shadow-xl border border-cream/15 pl-4 pr-2 py-2 flex items-center gap-2">
        <p className="flex-1 min-w-0 text-xs leading-snug">
          Install <b>Holy Words</b> — tap <b>Share</b>
          <Export size={13} weight="bold" className="inline -mt-0.5 mx-1" />
          then <b>Add to Home Screen</b>.
        </p>
        <button
          onClick={dismiss}
          aria-label="Dismiss"
          data-testid="a2hs-dismiss"
          className="shrink-0 w-7 h-7 grid place-items-center rounded-full text-cream/70 hover:text-cream hover:bg-cream/10 transition-colors"
        >
          <X size={14} weight="bold" />
        </button>
      </div>
    </div>
  );
}
